export const CorePaleBGPaletteDark: any = {
    0: '#BDC3CC',
    1: '#FFB3D1',
    2: '#FFB3D1',
    3: '#FAAEED',
    4: '#C7B6FC',
    5: '#C7B6FC',
    6: '#C7ECFF',
    7: '#C7ECFF',
    8: '#C7ECFF',
    9: '#A7ECE4',
    10: '#B0EDC0',
    11: '#B0EDC0',
    12: '#B0EDC0',
    13: '#A7ECE4',
    14: '#FDE8A5',
    15: '#FFD8B8',
    16: '#FFC5C2',
    17: '#BDC3CC',
    18: '#BDC3CC',
    19: '#DFC2B3',
    20: '#BBCEFF',
    21: '#BBCEFF',
    22: '#C7B6FC',
    23: '#BDC3CC',
    24: '#C7B6FC',
    25: '#BDC3CC',
    26: '#FFB3D1',
    27: '#9FAEFE',
    28: '#9EEDF8',
    29: '#B9F6D6',
    30: '#97D4B0',
    31: '#D7F1A4',
    32: '#FBB1AF',
    33: '#FFB4E1',
    34: '#DD9EE7',
    35: '#C291E0',
    36: '#B5A0E2',
    37: '#D7ACAC',
    38: '#BAACAC',
}